const NewsSection = () => {
  const news = [
    {
      date: { month: '12', day: '15' },
      category: 'お知らせ',
      title: '年末年始の営業日のご案内',
    },
    {
      date: { month: '11', day: '28' },
      category: '実績',
      title: '岡山市内メーカー様向けチタン製特注ネジの納品実績',
    },
    {
      date: { month: '11', day: '10' },
      category: '設備',
      title: '最新CNC旋盤を導入しました',
    },
    {
      date: { month: '10', day: '22' },
      category: 'イベント',
      title: '岡山市ものづくり展示会に出展いたしました',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-navy text-center mb-10 sm:mb-12 lg:mb-16">
          お知らせ
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
          {news.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer"
            >
              <div className="flex">
                <div className="w-20 sm:w-24 bg-navy flex flex-col items-center justify-center text-white flex-shrink-0">
                  <span className="text-2xl sm:text-3xl font-bold">{item.date.month}</span>
                  <span className="text-xs sm:text-sm">月</span>
                  <span className="text-2xl sm:text-3xl font-bold">{item.date.day}</span>
                  <span className="text-xs sm:text-sm">日</span>
                </div>
                <div className="flex-1 p-4 sm:p-6">
                  <span className="inline-block bg-navy text-white text-xs sm:text-sm px-3 py-1 rounded-full mb-2 sm:mb-3">
                    {item.category}
                  </span>
                  <h3 className="text-sm sm:text-base lg:text-lg font-bold text-navy group-hover:text-navy-light transition-colors line-clamp-2">
                    {item.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSection;